<template>
  <v-row>
    <v-col cols="12" md="6" class="d-flex align-end px-2">
      <v-text-field
        :value="search"
        placeholder="ค้นหาได้จากชื่อข่าว"
        hide-details
        outlined
        dense
        class="rounded-lg"
        clearable
        @input="$emit('update:search', $event)"
      >
        <template v-slot:append>
          <v-img
            src="@/assets/select/search_icon.png"
            width="16"
            height="16"
            class="mt-1"
            contain
          />
        </template>
      </v-text-field>
    </v-col>

    <v-col cols="12" md="3" class="px-2">
      <span class="title-select-text">สถานะ</span>
      <v-select
        v-model="statusModel"
        :items="statusItems"
        :menu-props="{ offsetY: true }"
        placeholder="ทั้งหมด"
        hide-details
        outlined
        dense
        class="rounded-lg short-field"
        item-text="text"
        item-value="value"
      >
        <template v-slot:append>
          <v-img
            src="@/assets/select/expand_icon.png"
            width="16"
            height="16"
            contain
            class="icon-rotate mt-1"
          />
        </template>
      </v-select>
    </v-col>
    
    <v-col cols="12" md="3" class="d-flex align-end justify-end px-2">
         <span
          class="clear-btn-text mb-2 ml-3"
          style="color: #5c96f8; cursor: pointer"
          @click="clearFilters"
        >
          ล้างค่า
        </span>
    </v-col>

  </v-row>
</template>

<script>
export default {
  name: "Select",

  props: {
    search: { type: String, default: "" },
    selectedStatus: { type: String, default: "" },
  },

  data() {
    return {
      statusItems: [
        { text: "ทั้งหมด", value: "" },
        { text: "เผยแพร่", value: "เผยแพร่" },
        { text: "ซ่อน", value: "ซ่อน" },
      ],
    };
  },

  computed: {
    statusModel: {
      get() {
        return this.selectedStatus || "";
      },
      set(v) {
        this.$emit("update:selected-status", v);
      },
    },
  },

  methods: {
    clearFilters() {
      this.$emit("update:search", "");
      this.$emit("update:selected-status", "");
    },
  },
};
</script>

<style scoped>
.title-select-text {
  font-size: 16px;
  font-weight: 400;
  color: #1f2a39;
}
.clear-btn-text {
  font-size: 14px;
  font-weight: 400;
}
.v-text-field--outlined >>> fieldset {
  border-color: #e5e7eb !important;
  border-radius: 8px !important;
}
.clear-btn-text:hover {
  text-decoration: underline;
}
.v-select .icon-rotate {
  transition: transform 0.3s ease;
}
.v-select.v-select--is-menu-active .icon-rotate {
  transform: rotate(180deg);
}
::v-deep(.v-select__selections),
::v-deep(.v-text-field__slot),
::v-deep(.v-label) {
  font-size: 14px !important;
  font-weight: 400 !important;
  color: #1f2a39 !important;
}
</style>
